import { useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { DEFAULT_LANGUAGE } from 'i18n';

import { createAnonymousUser, getUser } from 'data/actions/user';
import { idSelector } from 'data/selectors/user';

import { TOKEN_QUERY_PARAM_NAME } from './useLoginByTokenQueryParam';

export const useGetUser = ({ ignoreAuthToken = false }: { ignoreAuthToken?: boolean } = {}) => {
  const dispatch = useDispatch();
  const isCreatingUser = useRef(false);
  const userId = useSelector(idSelector);
  const { i18n } = useTranslation();

  const handleFailGetUser = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryUserId = searchParams.get('userId');

    if (!isCreatingUser.current) {
      isCreatingUser.current = true;
      dispatch(
        createAnonymousUser({
          userId: queryUserId || userId,
          locale: i18n.language || DEFAULT_LANGUAGE,
          onSuccess: () => dispatch(getUser({}))
        })
      );
    }
  };

  const getUserCallback = () => {
    const hasAuthToken = window.location.search.includes(`${TOKEN_QUERY_PARAM_NAME}=`);
    if (!userId && (ignoreAuthToken || !hasAuthToken)) {
      dispatch(getUser({ onFailed: handleFailGetUser }));
    }
  };

  return {
    getUser: getUserCallback
  };
};
